import {useEffect, useState} from 'react'

import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import {Box, Collapse, List, ListItemButton, ListItemText} from '@mui/material'
import {ChargeMenuType} from '../ChargeSettings'

type Props = {
  selectedMenu: ChargeMenuType
  onChangeMenu: (menu: ChargeMenuType) => void
  onMoveChargeInfo: () => void
}

const ChargeSidebar = ({selectedMenu, onChangeMenu, onMoveChargeInfo}: Props) => {
  const [openMeterReaderMenu, setOpenMeterReaderMenu] = useState(true)
  const [openMaintenanceMenu, setOpenMaintenanceMenu] = useState(true)

  useEffect(() => {
    if (selectedMenu === 'meter-readers' || selectedMenu === 'customer-transfer') {
      setOpenMeterReaderMenu(true)
    }

    if (selectedMenu === 'device-update' || selectedMenu === 'manufacturer-management') {
      setOpenMaintenanceMenu(true)
    }
  }, [selectedMenu])

  return (
    <Box
      sx={{
        width: 220,
        borderRight: '1px solid #e0e0e0',
        pr: 2,
      }}
    >
      <List component='nav'>
        <ListItemButton onClick={onMoveChargeInfo}>
          <ListItemText primary='요금연계' />
        </ListItemButton>

        <ListItemButton onClick={() => setOpenMeterReaderMenu((prev) => !prev)}>
          <ListItemText primary='검침원 관리' />
          {openMeterReaderMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openMeterReaderMenu} timeout='auto' unmountOnExit>
          <List component='div' disablePadding>
            <ListItemButton
              sx={{
                pl: 4,
                backgroundColor: selectedMenu === 'meter-readers' ? '#f3f4f6' : 'transparent',
              }}
              onClick={() => onChangeMenu('meter-readers')}
            >
              <ListItemText primary='검침원 목록' />
            </ListItemButton>

            <ListItemButton
              sx={{
                pl: 4,
                backgroundColor: selectedMenu === 'customer-transfer' ? '#f3f4f6' : 'transparent',
              }}
              onClick={() => onChangeMenu('customer-transfer')}
            >
              <ListItemText primary='검침원 변경' />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton onClick={() => setOpenMaintenanceMenu((prev) => !prev)}>
          <ListItemText primary='유지보수' />
          {openMaintenanceMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openMaintenanceMenu} timeout='auto' unmountOnExit>
          <List component='div' disablePadding>
            <ListItemButton
              sx={{
                pl: 4,
                backgroundColor: selectedMenu === 'device-update' ? '#f3f4f6' : 'transparent',
              }}
              onClick={() => onChangeMenu('device-update')}
            >
              <ListItemText primary='장비 업데이트' />
            </ListItemButton>

            <ListItemButton
              sx={{
                pl: 4,
                backgroundColor:
                  selectedMenu === 'manufacturer-management' ? '#f3f4f6' : 'transparent',
              }}
              onClick={() => onChangeMenu('manufacturer-management')}
            >
              <ListItemText primary='제조사 관리' />
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </Box>
  )
}

export default ChargeSidebar
